module.exports = __webpack_public_path__ + "static/thelittlelayup_og_fb_1200x630-ea2246ecf9b3110df7393f5bcacc30c4.png";